import React, { memo } from 'react'
import classNames from 'classnames'
import { INavigationRoute } from 'transfix-ui/components/NavigationBar/types'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import SubRoute from './SubRoute'

const useSubRoutesMenuStyles = makeStyles(() => ({
  root: {
    display: 'none',
    margin: 0,
    padding: 0,
    flex: '0 0 100%',
    width: '100%',
    color: brandColors.coolGray8,
  },
  open: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}))

interface ISubRoutesMenuProps {
  className?: string
  /**
   * @default false
   */
  isOpen?: boolean
  routes: INavigationRoute[]
  onClose: () => void
}

const SubRoutesMenu = memo<ISubRoutesMenuProps>(
  ({ className: classNameProp, routes: routesProp = [], isOpen = false, onClose }) => {
    const classes = useSubRoutesMenuStyles()
    const filteredRoutes = routesProp.filter(({ display }) => !!display)
    const className = classNames(classes.root, classNameProp, {
      [classes.open]: isOpen,
    })

    return (
      <ul className={className} data-test='SubRoutesMenu'>
        {filteredRoutes.map((childRoute, i) => (
          <SubRoute route={childRoute} key={String(i)} onClose={onClose} />
        ))}
      </ul>
    )
  }
)

export default SubRoutesMenu
